var $e41234e934efb4f5$exports = {};
$e41234e934efb4f5$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Stavka ".concat(args.item, " nije odabrana.");
  },
  "longPressToSelect": "Dugo pritisnite za ulazak u na\u010Din odabira.",
  "select": "Odaberite",
  "selectedAll": "Odabrane su sve stavke.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nije odabrana nijedna stavka",
      one: function one() {
        return "Odabrana je ".concat(formatter.number(args.count), " stavka");
      },
      other: function other() {
        return "Odabrano je ".concat(formatter.number(args.count), " stavki");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Stavka ".concat(args.item, " je odabrana.");
  }
};
export { $e41234e934efb4f5$exports as default };